import { useOnlineStatus } from '../../installer/pwa/useOnlineStatus';

const bar = {
  margin: '0 0 12px', padding: '8px 12px', borderRadius: 10,
  background: '#fff7ed', color: '#9a3412', border: '1px solid #fed7aa',
  fontSize: 12.5, fontWeight: 600, textAlign: 'center',
};

export default function OfflineBanner() {
  const online = useOnlineStatus();
  if (online) return null;
  return <div role="status" style={bar}>آفلاین - برخی امکانات محدود است</div>;
}
